<div class="upload-container">
  <div class="upload-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)" [class.drag-over]="isDragging"
    [class.invalid-file]="showInvalidFileError">

    <input type="file" #fileInput accept=".csv" (change)="onFileSelected($event)" style="display: none">

    <button (click)="fileInput.click()" [disabled]="isUploading">
      Seleccionar archivo CSV
    </button>

    <span *ngIf="selectedFile">
      {{ selectedFile.name }}
    </span>

    <p class="upload-hint">
      Solo se permiten archivos CSV
    </p>
  </div>

  <!-- Error de archivo inválido -->
  <div *ngIf="showInvalidFileError" class="error-message">
    Por favor, seleccione un archivo CSV válido
  </div>

  <!-- Barra de progreso -->
  <div class="progress-bar" *ngIf="isUploading">
    <div class="progress" [style.width.%]="uploadProgress">
      {{ uploadProgress }}%
    </div>
  </div>

  <!-- Mensaje de éxito -->
  <div *ngIf="uploadSuccess && uploadMessage" class="message success">
    {{ uploadMessage }}
  </div>

  <!-- Mensaje de error -->
  <div *ngIf="!uploadSuccess && msjError" class="message error">
    <strong>{{ msjError }}</strong>
    <ul *ngIf="lstErrores && lstErrores.length > 0">
      <li *ngFor="let error of lstErrores">{{ error }}</li>
    </ul>
  </div>

  <!-- Botones -->
  <div class="card flex justify-content-center gap-2">
    <p-button (click)="limpiar(fileInput)" [disabled]="isUploading" styleClass="p-button-raised">
      Limpiar
    </p-button>

    <p-button (click)="abrirModalEliminarBatch()" [disabled]="isUploading"
      styleClass="p-button-raised p-button-secondary">
      Eliminar Batch
    </p-button>
  </div>

</div>
<!-- 🔥 TABLA DE BATCHES (NUEVO) -->
<div class="mt-4">
  <p-table [value]="batches" [loading]="isLoadingBatches" [paginator]="true" [rows]="5" responsiveLayout="scroll"
    styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template pTemplate="caption"> Listado de Batches </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>No Batch</th>
        <th>Fecha</th>
        <th>No Productos</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-batch>
      <tr>
        <td>{{ batch.noBatch }}</td>
        <td>{{ batch.fecha | date:'dd/MM/yyyy' }}</td>
        <td>{{ batch.noProductos }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<!-- MODAL -->
<p-dialog header="Eliminar Batch" [(visible)]="visible" [style]="{width: '50vw'}">
  <ng-template pTemplate="header">
    <span class="text-xl font-bold">Eliminar Batch</span>
  </ng-template>

  <ng-template pTemplate="body">
    <h4>Ingrese el número de batch que desea eliminar:</h4>

    <div class="form-group">
      <label for="noBatch">Número de Batch:</label>
      <input type="text" pInputText id="noBatch" [(ngModel)]="noBatchEliminar" placeholder="Ej: 12345"
        [disabled]="isEliminando"
        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
        (keyup.enter)="confirmarEliminar()">
    </div>

    <div *ngIf="modalError" class="modal-error">
      {{ modalError }}
    </div>

    <div *ngIf="modalSuccess" class="modal-success">
      {{ modalSuccess }}
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button (click)="cerrarModal()" [disabled]="isEliminando" class="btn-cancelar">
      Cancelar
    </button>

    <button (click)="confirmarEliminar()" [disabled]="!noBatchEliminar || isEliminando" class="btn-eliminar">
      <span *ngIf="!isEliminando">Eliminar</span>
      <span *ngIf="isEliminando">Eliminando...</span>
    </button>
  </ng-template>
</p-dialog>